import EmailTemplateModal from './email-template-modal';

export default EmailTemplateModal;
